// 화면2 — 특징 추출·정합 더미 데이터

// 좌측 샷 선택 리스트 (화면1 드릴다운과 연동되는 샷 ID)
export const featureShotList = [
  { shotId: 'S-10248', productId: 'P-8848', status: 'done' },
  { shotId: 'S-10247', productId: 'P-8847', status: 'done' },
  { shotId: 'S-10246', productId: 'P-8846', status: 'done' },
  { shotId: 'S-10244', productId: 'P-8844', status: 'done' },
  { shotId: 'S-10243', productId: 'P-8843', status: 'done' },
  { shotId: 'S-10242', productId: 'P-8842', status: 'done' },
  { shotId: 'S-10241', productId: 'P-8841', status: 'done' },
];

export const defaultFeatureShotId = 'S-10248';

// ── 시계열(공정) : 사출압력·속도·보압 곡선 ──
// t = 사이클 진행 시간(ms 상대), 3개 채널
export const processTimeseries = Array.from({ length: 40 }, (_, i) => {
  const t = i * 50; // 0 ~ 1950ms
  // 충전(0~600) → 보압(600~1200) → 냉각(1200~) 형태를 흉내낸 곡선
  const fill = Math.max(0, Math.sin((i / 12) * Math.PI)) ;
  const pressure =
    i < 12 ? 40 + fill * 90 :          // 충전 구간 급상승
    i < 24 ? 130 - (i - 12) * 3.5 :    // 보압 구간 완만 하강
    72 - (i - 24) * 2.1;               // 냉각 하강
  const velocity =
    i < 12 ? 20 + fill * 65 :
    i < 24 ? 12 - (i - 12) * 0.6 :
    4;
  const holding =
    i < 12 ? 5 :
    i < 24 ? 60 - (i - 12) * 1.2 :
    Math.max(0, 46 - (i - 24) * 2.4);
  return {
    t,
    pressure: Math.round(Math.max(0, pressure) * 10) / 10,
    velocity: Math.round(Math.max(0, velocity) * 10) / 10,
    holding: Math.round(Math.max(0, holding) * 10) / 10,
  };
});

// 공정에서 추출된 핵심 특징값
export const processFeatures = [
  { labelKey: 'pages.moduleb.features.process.peakPressure', value: '128.4', unit: 'MPa' },
  { labelKey: 'pages.moduleb.features.process.holdTime', value: '3.20', unit: 's' },
  { labelKey: 'pages.moduleb.features.process.fillTime', value: '0.61', unit: 's' },
  { labelKey: 'pages.moduleb.features.process.chargeTime', value: '2.85', unit: 's' },
  { labelKey: 'pages.moduleb.features.process.maxSpeed', value: '84.6', unit: 'mm/s' },
  { labelKey: 'pages.moduleb.features.process.cushion', value: '5.4', unit: 'mm' },
];

// ── 형상(비전) : ROI / 윤곽선 특징 ──
export const visionFeatures = [
  { labelKey: 'pages.moduleb.features.vision.edgeDensity', value: '0.412', unit: '' },
  { labelKey: 'pages.moduleb.features.vision.defectCandidates', value: '3', unitKey: 'pages.moduleb.common.unitCount' },
  { labelKey: 'pages.moduleb.features.vision.contourCompleteness', value: '97.8', unit: '%' },
  { labelKey: 'pages.moduleb.features.vision.roiAreaRatio', value: '0.68', unit: '' },
];
// ROI 사각형 (제품 이미지 placeholder 좌표계 0~100 기준)
export const visionROIs = [
  { id: 'roi-1', x: 18, y: 22, w: 40, h: 30, labelKey: 'pages.moduleb.features.vision.roiShape' },
  { id: 'roi-2', x: 62, y: 55, w: 22, h: 20, labelKey: 'pages.moduleb.features.vision.roiDefect' },
];

// ── 온도장(열화상) : 캐비티 표면 온도 히트맵 (8x8 격자) ──
export const thermalColorbar = { min: 25, max: 120, unit: '℃' };
export const thermalGrid = (() => {
  const rows = 8, cols = 8;
  const grid = [];
  for (let r = 0; r < rows; r++) {
    const row = [];
    for (let c = 0; c < cols; c++) {
      // 우상단에 핫스팟을 둔 온도 분포
      const dx = c - 5.5, dy = r - 2.0;
      const dist = Math.sqrt(dx * dx + dy * dy);
      const temp = 112 - dist * 9 + ((r * 7 + c * 3) % 5);
      row.push(Math.max(28, Math.min(120, Math.round(temp))));
    }
    grid.push(row);
  }
  return grid;
})();
export const thermalStats = {
  hotspot: { row: 2, col: 6, temp: 118 },
  maxTemp: 118,
  avgTemp: 74.3,
  minTemp: 41,
};
export const thermalFeatures = [
  { labelKey: 'pages.moduleb.features.thermal.maxTemp', value: '118', unit: '℃' },
  { labelKey: 'pages.moduleb.features.thermal.avgTemp', value: '74.3', unit: '℃' },
  { labelKey: 'pages.moduleb.features.thermal.hotspot', value: '(6, 2)', unit: '' },
  { labelKey: 'pages.moduleb.features.thermal.stdDev', value: '19.6', unit: '℃' },
];

// ── 정합(Registration) 결과 ──
export const registration = {
  accuracy: 96.4,        // 정합 정확도(%)
  offsetPx: { x: 2.1, y: -1.4 }, // 오프셋(px)
  gridSize: 8,
};
